import Vue from 'vue';
import { updateField } from 'vuex-map-fields';

export default {
  START_LOADING_CONTACTS(state) {
    state.loadingContacts = true;
  },
  END_LOADING_CONTACTS(state) {
    state.loadingContacts = false;
  },
  SET_LOADING_ORGANISATION_CONTACTS(state, status) {
    state.loadingOrganisationContacts = status;
  },
  SET_CONTACTS(state, payload) {
    state.loadingContacts = false;
    state.contactList = payload;
  },
  RESET_ORGANISATION_CONTACTS(state) {
    state.organisationContactList = {
      data: [],
      links: {},
      meta: {},
    };

    state.organisationContactList = { ...state.organisationContactList };
  },
  SET_ORGANISATION_CONTACTS(state, payload) {
    // removed append functionality since we'll be using page-based loading - Elf, 2021-02-10
    state.organisationContactList.data = [...state.organisationContactList.data, ...payload.data];
    state.organisationContactList.links = payload.links;
    state.organisationContactList.meta = payload.meta;
    state.organisationContactList = { ...state.organisationContactList };
  },
  SET_ORGANISATION_CONTACTS_PAGE_LOADING(state, isLoading) {
    state.organisationContactPage.loading = isLoading;
  },
  SET_ORGANISATION_CONTACTS_PAGE_LIST(state, payload) {
    state.loadingContacts = false;
    state.organisationContactPage.list.data = payload.data;
    state.organisationContactPage.list.links = payload.links;
    state.organisationContactPage.list.meta = payload.meta;
  },
  UPDATE_ORGANISATION_CONTACTS_PAGE_RECORD(state, { contactId, changedData }) {
    // console.log('mutation received', contactId, changedData);
    // list of fields we are allowed to update
    const changeableFields = ['name', 'tags'];
    // find contact with contactId
    const record = state.organisationContactPage.list.data.find(c => c.id === contactId);

    if (record) {
      changeableFields.forEach((field) => {
        if (field in changedData) {
          record[field] = changedData[field];
        }
      });
    }
  },
  PREPEND_ORGANISATION_CONTACTS_PAGE_RECORD(state, prependContactsList) {
    // console.log('got', prependContactsList);
    state.organisationContactPage.list.data.unshift(...prependContactsList);
  },
  REMOVE_ONE_ORGANISATION_CONTACTS_PAGE_RECORD(state, contactId) {
    state.organisationContactPage.list.data = state.organisationContactPage.list.data.filter(c => c.id !== contactId);
  },
  UPDATE_CONTACT_CACHE(state, payload) {
    // TODO edit the contact cache on folder change, assignment change or getting conversation id if it is null initially
    if (!state.contactCache[payload.numberId]) {
      state.contactCache[payload.numberId] = {};
    }
    state.contactCache[payload.numberId] = payload.data;
  },
  CLEAR_CONTACT_CACHE(state) {
    state.contactCache = {};
  },
  REMOVE_CONTACT_FROM_CACHE(state, ids) {
    const numberIds = Object.keys(state.contactCache);
    numberIds.forEach((numberId) => {
      const targetContactIndex = state.contactCache[numberId].data.findIndex(c => ids.includes(c.id));
      if (targetContactIndex >= 0) {
        state.contactCache[numberId].data.splice(targetContactIndex, 1);
      }
    });

    state.contactCache = { ...state.contactCache };
  },
  START_LOADING_SUBSCRIBERS(state) {
    state.subscribersLoaded = false;
  },
  SET_SUBSCRIBERS(state, payload) {
    state.subscribersLoaded = true;
    state.subscriberList = payload;
  },
  START_LOADING_CONVERSATION_CONTACTS(state) {
    state.loadingConversationContacts = true;
  },
  SET_CONVERSATION_CONTACTS(state, payload) {
    state.conversationContactList = payload;
    state.loadingConversationContacts = false;
  },
  START_LOADING_CONTACT(state) {
    state.loadingContact = true;
  },
  END_LOADING_CONTACT(state) {
    state.loadingContact = false;
  },
  SET_CONTACT(state, payload) {
    state.contact = payload;
    state.loadingContact = false;
  },
  CONTACT_UPDATED(state, payload) {
    state.contactUpdated = payload;
  },
  CONTACT_DELETED(state, payload) {
    state.contactDeleted = payload;
  },

  SET_ACTIVITIES(state, payload) {
    state.activityList = payload;
    state.loadingActivities = false;
  },
  START_LOADING_ACTIVITIES(state) {
    state.loadingActivities = true;
  },

  START_LOADING_CONTACT_TAGS(state) {
    state.loadingContactTags = true;
  },
  SET_CONTACT_TAGS(state, payload) {
    state.contactTagList = payload;
    state.loadingContactTags = false;
  },
  SET_CONTACT_NOTES(state, payload) {
    state.contact.meta_data.notes = payload;
  },
  CONTACT_TAG_CREATED(state, payload) {
    state.contactTagCreated = payload;
    if (payload) {
      state.contactTagList.push(payload);
    }
  },
  CONTACT_TAG_UPDATED(state, payload) {
    state.contactTagUpdated = payload;
  },
  CONTACT_TAG_DELETED(state, payload) {
    state.contactTagDeleted = payload;
  },

  START_LOADING_CUSTOM_FIELDS(state) {
    state.loadingCustomFields = true;
  },
  SET_CUSTOM_FIELDS(state, payload) {
    state.customFieldList[payload.organisationId] = payload.data;
    state.customFieldList = { ...state.customFieldList };
    state.loadingCustomFields = false;
  },
  REMOVE_CUSTOM_FIELD(state, payload) {
    state.customFieldList[payload.organisationId] = state.customFieldList[payload.organisationId].filter(customField => customField.id !== payload.contactFieldId);
  },
  CUSTOM_FIELD_SAVED(state, payload) {
    state.customFieldSaved = payload;
  },
  UPDATE_CONTACT_FIELDS_LIST(state, payload) {
    state.customFieldList[payload.organisationId].push(payload.field);
    state.customFieldList[payload.organisationId] = [...state.customFieldList[payload.organisationId].sort((a, b) => (b.name.toUpperCase() < a.name.toUpperCase() ? 1 : (b.name.toUpperCase() > a.name.toUpperCase() ? -1 : 0)))];
  },
  UPDATE_CONTACT_FIELDS(state, payload) {
    const targetCustomField = state.customFieldList[payload.organisationId].find(cf => cf.id === payload.field.id);
    if (targetCustomField) {
      targetCustomField.name = payload.field.name;
      targetCustomField.options = [...payload.field.options];
    }
  },
  CUSTOM_FIELD_DELETED(state, payload) {
    state.customFieldDeleted = payload;
  },
  ADD_CUSTOM_FIELD(state, payload) {
    state.customFieldList[payload.organisationId].push(payload.data);
    state.customFieldList[payload.organisationId] = [...state.customFieldList[payload.organisationId].sort((a, b) => (b.name.toUpperCase() < a.name.toUpperCase() ? 1 : (b.name.toUpperCase() > a.name.toUpperCase() ? -1 : 0)))];
  },
  EDIT_CUSTOM_FIELD(state, payload) {
    const targetCustomField = state.customFieldList[payload.organisationId].find(cf => cf.id === payload.data.id);
    if (targetCustomField) {
      targetCustomField.name = payload.data.name;
      targetCustomField.options = [...payload.data.options];
    }
    state.customFieldList[payload.organisationId] = [...state.customFieldList[payload.organisationId].sort((a, b) => (b.name.toUpperCase() < a.name.toUpperCase() ? 1 : (b.name.toUpperCase() > a.name.toUpperCase() ? -1 : 0)))];
  },
  CUSTOM_FIELD_CHANGED(state, payload) {
    state.customFieldChange = {
      newName: payload.name,
      oldName: payload.oldName,
    };
  },
  DELETE_SINGLE_CUSTOM_FIELD(state, payload) {
    state.customFieldDeleted = payload.customFieldId;
    state.customFieldList[payload.organisationId] = state.customFieldList[payload.organisationId].filter(qr => qr.id !== payload.customFieldId);
  },
  CONTACT_NOTES_SYNCED(state, payload) {
    state.contactNotesSynced = payload;
  },
  CUSTOM_FIELDS_SYNCED(state, payload) {
    state.customFieldsSynced = payload;
  },
  CONTACT_TAGS_SYNCED(state, payload) {
    state.contactTagsSynced = payload;
  },
  SET_IMPORT_ID(state, payload) {
    state.importId = payload;
  },
  SET_IMPORT_ERROR(state, payload) {
    state.importError = payload;
  },
  START_CALCULATING_UNIQUE_CONTACTS(state) {
    state.calculatingUniqueContacts = true;
  },
  SET_UNIQUE_CONTACTS_COUNT(state, payload) {
    state.calculatingUniqueContacts = false;
    state.uniqueContactsCount = payload;
  },
  SET_UNIQUE_ERROR(state) {
    state.calculatingUniqueContacts = false;
    state.uniqueContactsCount = '-';
  },
  RESET_UNIQUE_CONTACT_COUNT(state) {
    state.uniqueContactsCount = 0;
  },
  SET_EXPORT_ID(state, payload) {
    state.exportId = payload;
  },
  SET_EXPORT_ERROR(state, payload) {
    state.exportError = payload;
  },
  UPDATE_CONTACT_DATA(state, payload) {
    if (state.contact.id === payload.id) {
      state.contact = payload;
    }
  },

  API_ERROR(state, payload) {
    if (payload) {
      state.apiError = payload;
    }
  },
  updateField,
};
